import { render } from "./share-posts.vue?vue&type=template&id=464711cc&scoped=true"
import script from "./share-posts.vue?vue&type=script&lang=js"
export * from "./share-posts.vue?vue&type=script&lang=js"

import "./share-posts.vue?vue&type=style&index=0&id=464711cc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-464711cc"]])

export default __exports__